import React, { useRef, useEffect, useContext } from 'react';
// import useNebula from 'hooks/useNebula';
import { makeStyles } from '@material-ui/core/styles';
import AppContext from '../../AppContext';

const useStyles = makeStyles((theme) => ({
  viz: {
    height: 350,
    width: '100%',
    '& > div': {
      backgroundColor: 'transparent',
    },
    [theme.breakpoints.down('xs')]: {
      height: 200,
    },
  },
}));

const Pie = () => {
  const { nebula } = useContext(AppContext);

  // const nebula = useNebula();
  const elementRef = useRef();
  const vizRef = useRef();

  useEffect(async () => {
    if (!nebula) return;

    vizRef.current = await nebula.render({
      element: elementRef.current,
      type: 'pie2022',
      fields: [
        {
          qDef: {
            qFieldDefs: ["=ValueList('No PoC', '1 PoC', '+1 PoC')"],
            qSortCriterias: [
              {
                qSortByExpression: -1,
                qExpression: {
                  qv: `num(If(ValueList('No PoC', '1 PoC', '+1 PoC')='No PoC',

                  Count(distinct {<[Name of media outlet for search - 2022]=, [Top 3 Supervisor - Visible Minorities or Indigenous - Men - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Women - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Non-Binary - 2022]={'0'}>}[Name of media outlet completing the survey - 2022])
             /
             count(distinct [Name of media outlet completing the survey - 2022]),
             
             If(ValueList('No PoC', '1 PoC', '+1 PoC')='1 PoC',
             
             
                  (Count(distinct {<[Top 3 Supervisor - Visible Minorities or Indigenous - Men - 2022]={'1'},[Top 3 Supervisor - Visible Minorities or Indigenous - Women - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Non-Binary - 2022]={'0'}>}[Name of media outlet completing the survey - 2022])
             +Count(distinct {<[Top 3 Supervisor - Visible Minorities or Indigenous - Men - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Women - 2022]={'1'},[Top 3 Supervisor - Visible Minorities or Indigenous - Non-Binary - 2022]={'0'}>}[Name of media outlet completing the survey - 2022])
             +Count(distinct {<[Top 3 Supervisor - Visible Minorities or Indigenous - Men - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Women - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Non-Binary - 2022]={'1'}>}[Name of media outlet completing the survey - 2022])
             )
             /
             count(distinct [Name of media outlet completing the survey - 2022]),
             
             1-(Count(distinct {<[Name of media outlet for search - 2022]=, [Top 3 Supervisor - Visible Minorities or Indigenous - Men - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Women - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Non-Binary - 2022]={'0'}>}[Name of media outlet completing the survey - 2022])
             /
             count(distinct [Name of media outlet completing the survey - 2022])+
             (Count(distinct {<[Name of media outlet for search - 2022]=, [Top 3 Supervisor - Visible Minorities or Indigenous - Men - 2022]={'1'},[Top 3 Supervisor - Visible Minorities or Indigenous - Women - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Non-Binary - 2022]={'0'}>}[Name of media outlet completing the survey - 2022])
             +Count(distinct {<[Name of media outlet for search - 2022]=, [Top 3 Supervisor - Visible Minorities or Indigenous - Men - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Women - 2022]={'1'},[Top 3 Supervisor - Visible Minorities or Indigenous - Non-Binary - 2022]={'0'}>}[Name of media outlet completing the survey - 2022])
             +Count(distinct {<[Name of media outlet for search - 2022]=, [Top 3 Supervisor - Visible Minorities or Indigenous - Men - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Women - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Non-Binary - 2022]={'1'}>}[Name of media outlet completing the survey - 2022])
             )
             /
             count(distinct [Name of media outlet completing the survey - 2022])))),'#,##0.0')`,
                },
              },
            ],
            autoSort: false,
          },
        },
        {
          qDef: {
            qDef: `num(If(ValueList('No PoC', '1 PoC', '+1 PoC')='No PoC',

            Count(distinct {<[Name of media outlet for search - 2022]=, [Top 3 Supervisor - Visible Minorities or Indigenous - Men - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Women - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Non-Binary - 2022]={'0'}>}[Name of media outlet completing the survey - 2022])
       /
       count(distinct {<[Name of media outlet for search - 2022]=>} [Name of media outlet completing the survey - 2022]),
       
       If(ValueList('No PoC', '1 PoC', '+1 PoC')='1 PoC',
       
       
            (Count(distinct {<[Name of media outlet for search - 2022]=, [Top 3 Supervisor - Visible Minorities or Indigenous - Men - 2022]={'1'},[Top 3 Supervisor - Visible Minorities or Indigenous - Women - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Non-Binary - 2022]={'0'}>}[Name of media outlet completing the survey - 2022])
       +Count(distinct {<[Name of media outlet for search - 2022]=, [Top 3 Supervisor - Visible Minorities or Indigenous - Men - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Women - 2022]={'1'},[Top 3 Supervisor - Visible Minorities or Indigenous - Non-Binary - 2022]={'0'}>}[Name of media outlet completing the survey - 2022])
       +Count(distinct {<[Name of media outlet for search - 2022]=, [Top 3 Supervisor - Visible Minorities or Indigenous - Men - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Women - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Non-Binary - 2022]={'1'}>}[Name of media outlet completing the survey - 2022])
       )
       /
       count(distinct {<[Name of media outlet for search - 2022]=>} [Name of media outlet completing the survey - 2022]),
       
       1-(Count(distinct {<[Name of media outlet for search - 2022]=, [Top 3 Supervisor - Visible Minorities or Indigenous - Men - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Women - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Non-Binary - 2022]={'0'}>}[Name of media outlet completing the survey - 2022])
       /
       count(distinct {<[Name of media outlet for search - 2022]=>} [Name of media outlet completing the survey - 2022])+
       (Count(distinct {<[Name of media outlet for search - 2022]=, [Top 3 Supervisor - Visible Minorities or Indigenous - Men - 2022]={'1'},[Top 3 Supervisor - Visible Minorities or Indigenous - Women - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Non-Binary - 2022]={'0'}>}[Name of media outlet completing the survey - 2022])
       +Count(distinct {<[Name of media outlet for search - 2022]=, [Top 3 Supervisor - Visible Minorities or Indigenous - Men - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Women - 2022]={'1'},[Top 3 Supervisor - Visible Minorities or Indigenous - Non-Binary - 2022]={'0'}>}[Name of media outlet completing the survey - 2022])
       +Count(distinct {<[Name of media outlet for search - 2022]=, [Top 3 Supervisor - Visible Minorities or Indigenous - Men - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Women - 2022]={'0'},[Top 3 Supervisor - Visible Minorities or Indigenous - Non-Binary - 2022]={'1'}>}[Name of media outlet completing the survey - 2022])
       )
       /
       count(distinct {<[Name of media outlet for search - 2022]=>} [Name of media outlet completing the survey - 2022])))),'#,##0.0')`,
            qNumFormat: {
              qType: 'I',
              qnDec: 2,
              qUseThou: 0,
              qFmt: '####%',
              qDec: '.',
            },
          },

        },
      ],
    });
  }, [nebula]);

  const classes = useStyles();
  return (
    <>
      <div id="pieViz" className={classes.viz} ref={elementRef} />
    </>
  );
};

export default Pie;
